import { ShieldCheck } from "lucide-react";
import { AuditTrailTable } from "@/components/admin/AuditTrailTable";

export function AuditTrailPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="rounded-lg bg-primary/10 p-2">
          <ShieldCheck className="size-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold">Audit Trail</h1>
          <p className="text-sm text-muted-foreground">
            Append-only log of all system events and authentication activity.
          </p>
        </div>
      </div>

      <AuditTrailTable />
    </div>
  );
}
